import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {UserService} from '../services/user.service';
import {User} from '../../models/user';
import {ObjectUtils} from '../utils/object.utils';


@Injectable()
export class InfluencerGuard implements CanActivate, CanActivateChild {

  constructor(private auth: AuthService, private userService: UserService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.userService.getInfluencerInfo()) {
      return true;
    } else {
      const currentUser = ObjectUtils.parseJSON(localStorage.getItem('user')) as User;
      if (!currentUser) {
        return false;
      }
      return this.auth.authInfluencerFromServer(currentUser.companyId, state.url);
    }
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/influencer.guard.ts